import UserRegistrationModel from './UserRegistration';
import UserRegistrationInfo from './components/UserRegistrationInformation';
import VetRegistrationInfo from './components/VetRegistrationInformation';

export const UserRegistration = UserRegistrationModel;
export const UserRegistrationInformation = UserRegistrationInfo;
export const VetRegistrationInformation = VetRegistrationInfo;
